// Use a calendar date rather than elapsed milliseconds: leap years and time zones
// must not move a plant's anniversary. The reference date is serialized by Nuxt.
export function journalToday(now=new Date()){
 const parts=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Moscow',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now);
 const get=type=>parts.find(part=>part.type===type).value;
 return `${get('year')}-${get('month')}-${get('day')}`;
}
function calendar(value){
 if(!/^\d{4}-\d{2}-\d{2}$/.test(String(value||'')))return null;
 const date=new Date(value+'T00:00:00Z');
 return Number.isFinite(date.getTime())&&date.toISOString().slice(0,10)===value?String(value).split('-').map(Number):null;
}
export function plantAge(value,today=journalToday()){
 const date=calendar(value),reference=calendar(today);
 if(!date||!reference)return '—';
 if(value>today)return 'План';
 let years=reference[0]-date[0];
 if(reference[1]<date[1]||(reference[1]===date[1]&&reference[2]<date[2]))years--;
 if(years<1)return 'До года';
 const ten=years%10,hundred=years%100;
 return `${years} ${hundred>=11&&hundred<=14?'лет':ten===1?'год':ten>=2&&ten<=4?'года':'лет'}`;
}
export function plantAgeHint(value){
 if(!calendar(value))return 'Укажите дату посева или посадки для расчёта возраста';
 return `Дата посева / посадки: ${value.slice(8,10)}.${value.slice(5,7)}.${value.slice(0,4)}`;
}
